import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_InfoBox = _resolveComponent("InfoBox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_AutoCompleteField = _resolveComponent("AutoCompleteField")!
  const _component_FileUploadField = _resolveComponent("FileUploadField")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.model && _ctx.model.Id ? "Edit Certificate" : "Add Certificate"), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, {
            ref: "frmRegister",
            modelValue: _ctx.valid,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.valid) = $event)),
            "lazy-validation": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InfoBox, { title: "Add Your Certificates Here" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_TextField, {
                        readonly: _ctx.isHiringmanager,
                        showRequired: "",
                        dense: "",
                        rules: [_ctx.validations.required],
                        outlined: "",
                        label: "Certificate Name",
                        placeholder: "Certificate Name",
                        modelValue: _ctx.model.Name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.Name) = $event))
                      }, null, 8, ["readonly", "rules", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AutoCompleteField, {
                        readonly: _ctx.isHiringmanager,
                        rules: [_ctx.validations.required, _ctx.validations.arrayMinLength(1)],
                        showRequired: "",
                        label: "Skill",
                        "persistent-hint": "",
                        hint: "The first items of this field come from 'Technical Skills' that you can find it under Skills tab.",
                        dense: "",
                        placeholder: "Select Skill...",
                        modelValue: _ctx.model.SkillIds,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.SkillIds) = $event)),
                        items: _ctx.teammemberSkillList,
                        "item-title": "Name",
                        "item-value": "id",
                        multiple: "",
                        chips: "",
                        "deletable-chips": "",
                        outlined: ""
                      }, null, 8, ["readonly", "rules", "modelValue", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_TextField, {
                        readonly: _ctx.isHiringmanager,
                        rules: [_ctx.validations.required],
                        showRequired: "",
                        dense: "",
                        outlined: "",
                        label: "Issuing organisation",
                        placeholder: "Issuing Organisation",
                        modelValue: _ctx.model.Organization,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.Organization) = $event))
                      }, null, 8, ["readonly", "rules", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AutoCompleteField, {
                        readonly: _ctx.isHiringmanager,
                        rules: [_ctx.validations.required],
                        showRequired: "",
                        dense: "",
                        label: "Year of Acquisition",
                        placeholder: "Year of Acquisition",
                        modelValue: _ctx.model.Year,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.Year) = $event)),
                        outlined: "",
                        items: _ctx.yearsList
                      }, null, 8, ["readonly", "rules", "modelValue", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    md: "6",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_FileUploadField, {
                        modelValue: _ctx.currentFile,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentFile) = $event)),
                        "show-size": _ctx.showSize,
                        readonly: _ctx.isHiringmanager,
                        accept: ".pdf,.doc,.docx,.png,.jpg",
                        dense: "",
                        "small-chips": "",
                        outlined: "",
                        label: "Upload your Certificate File",
                        "prepend-icon": "",
                        onChange: _ctx.fileChanged
                      }, null, 8, ["modelValue", "show-size", "readonly", "onChange"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, { class: "justify-end" }, {
        default: _withCtx(() => [
          (!_ctx.isHiringmanager)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                class: "secondary_btn",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cancel())),
                loading: _ctx.loading,
                "prepend-icon": "mdi-cancel"
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode(" Cancel")
                ])),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          (!_ctx.isHiringmanager)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                class: "primary_btn",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.save())),
                loading: _ctx.loading,
                "prepend-icon": "mdi-check"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.model.Id == "" ? "Add Certificate" : "Save Certificate"), 1)
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}